import { loadCouponReasonTypes } from ".";
import { loadStatus } from "../entitiesType";
import store, { type AppState, UsePortalSelector } from "../..";

const selectCouponReasonTypes = (_: AppState) => {
    const dispatch = store.dispatch;
    const currentState = store.getState().entity.couponReasonTypes;
    const currentUser = store.getState().user;
    if ((
        currentState.loadStatus === loadStatus.needsLoaded || currentState.loadStatus === loadStatus.notLoaded
    ) && currentUser.id !== 0) {
        dispatch(loadCouponReasonTypes());
    }
    return currentState.list;
};

const useCouponReasonTypes = () => UsePortalSelector(selectCouponReasonTypes);

export { useCouponReasonTypes, selectCouponReasonTypes };
